<template>
    <div>
        <!-- section-考试类别 -->
        <section class="section-grade-type section" style="padding-top: 0;">
            <div class="container">
                <div class="exam-introduce-box intro">
                    <h3 class="heading-tertiary">TDA-G12介绍</h3>
                    <div class="exam-introduce color-area-one">
                        <div class="exam-introduce-title">考试定位</div>
                        <div class="exam-introduce-text">
                            TDA-G12
                            集「高考诊断」与「强基诊断」于一体，为不同目标的高中生提供高质量的学术能力诊断；并通过「一年三次」的考试设置，以长程动态的视角帮助中学和学生精准定位学科能力、及时调整学习策略、明确升学方向，并将目标化为内在驱动力，最终迈入理想学府。
                        </div>
                    </div>
                    <div class="exam-introduce color-area-two">
                        <div class="exam-introduce-title">考试目的</div>
                        <div class="exam-introduce-text">旨在检验学生在高三各复习阶段的学科表现，并为数理单科特长学生提供加试科目考查，助力高考冲刺及高校特殊类型考试准备。</div>
                    </div>
                </div>
                <div class="exam-introduce-box intro">
                    <div class="section-grade-type-box">
                        <h3 class="heading-tertiary">面向群体</h3>
                        <h3 class="heading-sixth" style="text-align: left;">面向学生</h3>
                        <div class="heading-third">
                            TDA-G12 主要面向全体高三学生及成绩突出的高一和高二学生，按需求分为以下四类。无论是哪种类型的考生，都能在这里找到自己的专属考试方案。
                        </div>
                        <div class="box-area-grid grid-col-2 gap-32">
                            <div class="box-area-grid-item bg_color_gray">
                                <div class="box-area-grid-title">1. 强基冲刺生</div>
                                <div class="box-area-grid-text">
                                    学科综合能力优秀、具备数理单科特长，且已明确将顶尖院校「强基计划」作为升学目标的高三学生。
                                </div>
                                <div class="box-area-grid-text box-area-grid-ul">
                                    <div class="box-area-grid-text">
                                        <span class="bold">核心需求</span>
                                    </div>
                                    <ul class="box-area-grid-ul">
                                        <li>强基精准定位: 明确自身在顶尖强基生中的相对位置</li>
                                        <li>查漏补缺: 针对性诊断强基笔试中的高阶知识盲区</li>
                                        <li>实战演练: 提前适应强基笔试的机考模式、题型、难度与压力</li>
                                        <li>巩固高考优势: 了解自身的高考学科表现，巩固高考优势并寻求在高考和强基备考的平衡</li>
                                    </ul>
                                </div>
                                <div class="box-area-grid-text bg-text">
                                    <span class="bold">参试建议：</span>高考诊断+强基诊断(线上机考模式)
                                </div>
                            </div>
                            <div class="box-area-grid-item bg_color_gray">
                                <div class="box-area-grid-title">2. 强基探索生</div>
                                <div class="box-area-grid-text">
                                    学科综合能力良好，具备一定的数理特长，但对自身能否冲击「强基计划」尚不确定的高三学生。<br/>
                                    具备数理单科特长，但学科综合能力有待提升，希望冲击「强基计划」的高三学生。
                                </div>
                                <div class="box-area-grid-text box-area-grid-ul">
                                    <div class="box-area-grid-text">
                                        <span class="bold">核心需求</span>
                                    </div>
                                    <ul class="box-area-grid-ul">
                                        <li>高考保底: 了解通过高考冲击一流高校（"985""211"或"双一流"）成功概率</li>
                                        <li>强基潜力评估: 客观判断自己冲击强基计划的成功概率</li>
                                        <li>路径决策: 明确个人精力应聚焦于强基备考还是高考冲刺，或寻求二者平衡</li>
                                        <li>强基差距分析: 了解自身与强基入圍水平的具体差距</li>
                                    </ul>
                                </div>
                                <div class="box-area-grid-text bg-text">
                                    <span class="bold">参试建议：</span>高考诊断+强基诊断(线上机考模式)
                                </div>
                            </div>
                            <div class="box-area-grid-item bg_color_gray">
                                <div class="box-area-grid-title">3. 高考主力军</div>
                                <div class="box-area-grid-text">
                                    <span class="bold">描述：</span>以高考为核心备考路径，目标是通过统一高考进入理想大学的全体高三学生。
                                </div>
                                <div class="box-area-grid-text box-area-grid-ul">
                                    <div class="box-area-grid-text">
                                        <span class="bold">核心需求</span>
                                    </div>
                                    <ul class="box-area-grid-ul">
                                        <li>高考水平评估: 了解自身高考水平进入一流高校的成功可能性或差距</li>
                                        <li>高考知识点诊断: 全面检测高考知识点的掌握情况，识别失分点</li>
                                        <li>优质模拟: 通过高质量高考模拟题保持「做题手感」和备考状态</li>
                                    </ul>
                                </div>
                                <div class="box-area-grid-text bg-text">
                                    <span class="bold">参试建议：</span>高考诊断(纸笔模式)
                                </div>
                            </div>
                            <div class="box-area-grid-item bg_color_gray">
                                <div class="box-area-grid-title">4. 低年级英才</div>
                                <div class="box-area-grid-text">
                                    <span class="bold">描述：</span>学科综合能力出众或单科优势明显，希望冲击「少年班」或提前备战高考/强基计划的高一、高二学生。
                                </div>
                                <div class="box-area-grid-text box-area-grid-ul">
                                    <div class="box-area-grid-text">
                                        <span class="bold">核心需求</span>
                                    </div>
                                    <ul class="box-area-grid-ul">
                                        <li>「少年班」准备: 通过高考和强基诊断试题巩固高中知识并适应大学对数理学科的考查视角，冲刺「少年班」</li>
                                        <li>能力校准: 对标高年级顶尖水平，明确长期努力方向</li>
                                        <li>赛道选择: 初步探索个人特长与未来升学路径的最佳匹配</li>
                                    </ul>
                                </div>
                                <div class="box-area-grid-text bg-text">
                                    <span class="bold">参试建议：</span>根据个人情况选择相应诊断模式
                                </div>
                            </div>
                            <div class="box-area-grid-item box-area-grid-item-lang bg_color_buff">
                                <div class="box-area-grid-title">特别提示（「强基 B 类考生」不能错过）</div>
                                <div class="box-area-grid-text">
                                    「强基诊断」专为拟冲击顶尖院校「强基计划」的「强基 B
                                    类考生」（通常指在五大学科竞赛中获银牌及以上奖项的「破格生」）提供单独的全国排名，旨在为准备报考「清北」等实施「B
                                    类」强基计划的院校的考生，提供强基学科水平参考。
                                </div>
                                <div class="box-area-grid-text">
                                    因此，我们推荐在「五大联赛」中能达到全国决赛银牌及以上水平的学生参与「强基诊断」。
                                </div>
                            </div>
                        </div>
                        <h3 class="heading-sixth" style="text-align: left;margin-top: 5rem">面向中学</h3>
                        <div class="heading-third">
                            TDA-G12 适合不同高中教学策略及需求的高中参与（特别是一流高校的生源高中），主要解决中学的以下问题：
                        </div>
                        <div class="box-area-grid grid-col-2 gap-24">
                            <div class="box-area-grid-item">
                                <div class="box-area-grid-text flex-row">
                                    <i class="ph-bold ph-number-one"></i>
                                    <span>顶尖生定位：了解本校尖子生在本省或全国范围的「高考」或「强基」排名</span>
                                </div>
                            </div>
                            <div class="box-area-grid-item">
                                <div class="box-area-grid-text flex-row">
                                    <i class="ph-bold ph-number-two"></i>
                                    <span>升学路径决策：通过数据（如强基入围及 985 高校达线可能性预测）辅助学生和家长做出更合适的升学路径选择</span>
                                </div>
                            </div>
                            <div class="box-area-grid-item">
                                <div class="box-area-grid-text flex-row">
                                    <i class="ph-bold ph-number-three"></i>
                                    <span>「强基」人才培养体系诊断：采用一套客观评估工具，持续追踪和衡量学校「强基」人才培养成效</span>
                                </div>
                            </div>
                            <div class="box-area-grid-item">
                                <div class="box-area-grid-text flex-row">
                                    <i class="ph-bold ph-number-four"></i>
                                    <span>精准教学诊断：在教学上，能精准定位学生高考备考中的知识薄弱点和群体共性问题，以实现高效的查漏补缺</span>
                                </div>
                            </div>
                            <div class="box-area-grid-item">
                                <div class="box-area-grid-text flex-row">
                                    <i class="ph-bold ph-number-five"></i>
                                    <span>高水平实战演练：使用「高考」或「强基」的高质量试题，让学生提前演练，适应正式考试的形式、命题风格、节奏和竞争压力</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="exam-introduce-box intro">
                    <div class="section-grade-type-box">
                        <h3 class="heading-tertiary">基本信息</h3>
                        <div class="box-area-grid box-area-grid--new grid-col-2 gap-24">
                            <div class="box-area-grid-item bg_line_1">
                                <div class="box-area-grid-title">报名方式</div>
                                <div class="box-area-grid-text">
                                    TDA-G12：以中学报名为主 <br/>
                                    强基诊断（居家考）：以个人报名为主
                                </div>
                            </div>
                            <div class="box-area-grid-item bg_line_2">
                                <div class="box-area-grid-title">考试形式</div>
                                <div class="box-area-grid-text">
                                    中学：线上机考（高考诊断+强基诊断）、线下纸笔（高考诊断） <br/>
                                    个人：居家考（强基诊断）
                                </div>
                            </div>
                            <div class="box-area-grid-item bg_line_3 box-area-grid-item-lang">
                                <div class="box-area-grid-title">科目设置</div>
                                <div class="box-area-grid box-area-grid--small grid-col-2">
                                    <div class="box-area-grid-item bg_line_6">
                                        <div class="box-area-grid-title">高考诊断：</div>
                                        <div class="box-area-grid-text">
                                            语文、数学、英语、物理、化学、生物、历史、地理、政治
                                        </div>
                                        <div class="box-area-grid-text">
                                            *注：政治科目仅在本学年最后一次考试中设置。
                                        </div>
                                    </div>
                                    <div class="box-area-grid-item bg_line_6">
                                        <div class="box-area-grid-title">强基诊断：</div>
                                        <div class="box-area-grid-text">
                                            数学、物理、化学
                                        </div>
                                        <div class="box-area-grid-text">
                                            *注：化学科目在本学年最后两次考试中设置。
                                        </div>
                                    </div>
                                </div>
                                <div class="box-area-grid-text">
                                    高考诊断选科方式：按高考改革区选科方式
                                </div>
                            </div>
                            <div class="box-area-grid-item bg_line_4 box-area-grid-item-lang">
                                <div class="box-area-grid-title">考查范围</div>
                                <div class="box-area-grid box-area-grid--small grid-col-2">
                                    <div class="box-area-grid-item bg_line_7">
                                        <div class="box-area-grid-text">
                                            <div class="box-area-grid-title" style="display: inline;">高考诊断：</div>
                                            普通高中课程标准要求范围，命题视角及试题形式均对标高考，试题难度大部分与改革区高考相当，部分试题略难于高考以拉开区分度
                                        </div>
                                    </div>
                                    <div class="box-area-grid-item bg_line_7">
                                        <div class="box-area-grid-text">
                                            <div class="box-area-grid-title" style="display: inline;">强基诊断：</div>
                                            大学教授命题，遵循大学选才视角，试题难度对标顶尖高校强基
                                        </div>
                                    </div>
                                </div>
                                <div class="box-area-grid-text">
                                    高考诊断选科方式：按高考改革区选科方式
                                </div>
                            </div>
                            <div class="box-area-grid-item bg_line_5 box-area-grid-item-lang">
                                <div class="box-area-grid-title">数据服务</div>
                                <div class="box-area-grid-text">
                                    <ul>
                                        <li>
                                            中学：数据型试题讲义(年级版和班级版)、成绩数据表(总分表(年级版)、总分表(班级版)、学科小题分表(年级版)、学科小题分表(班级版))、中学综合分析报告(年级版)、中学综合分析报告(班级版)、中学学科分析报告(年级版)、中学学科分析报告(班级版)。
                                        </li>
                                        <li>学生：学生基础报告、学生预测报告、认证成绩单(仅限线上机考)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- section-考试服务介绍 -->
        <section class="section-intro section" id="section-intro">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--features">
                    <p class="section-title">
                        <span class="section-title-text">TDA试题特点</span>
                    </p>
                </h2>

                <!-- TDA常规科目试题介绍 -->
                <div class="normal-subject-dev-intro intro">
                    <h3 class="intro-title heading-tertiary">
                        <!--<span class="intro-title-number">01 </span>-->
                        <span class="intro-title-text">高考诊断：对标高考，精准模拟，助力高考冲刺备考</span>
                    </h3>
                    <div class="intro-content">
                        <div class="normal-subject-section intro-section">
                            <div class="service">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>高考诊断</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">TDA-G12 适用于全体高三学生及成绩突出的高一和高二学生，旨在提供高质量的高考模拟体验。试题命制严格以中国高考评价体系、普通高中课程方案和各个学科课程标准为依据，考查形式完全对标高考，试题难度大部分与改革区高考相当，部分试题略难于高考以拉开区分度，具备高信度和效度，帮助学生进行实战化冲刺备考。</span>
                                        <span class="paragraph">命题专家团队是高质量命题的基本保障，拥有近 200 名成员，具备十年以上教学经验，五届以上高三教学经验，并参与过多次省、市、区级大规模考试原创命题工作。</span>
                                    </p>
                                    <div class="subject-resource">
                                        <p class="tips">
                                            *点击按钮直接下载高考诊断科目样卷或扫描二维码购买历史真题
                                        </p>
                                        <a
                                                href="https://www.cssat.cn/example/高考诊断科目样卷.zip"
                                                class="btn btn--full btn--download btn--link"
                                        >
                                            <span>下载高考诊断科目样卷</span>
                                            <i class="ph-bold ph-download-simple icon--download"></i>
                                        </a>
                                        <img
                                                class="subject-excercise-qrcode"
                                                src="../../assets/img/tda-dev/subject-excercise-qrcode.png"
                                                alt="历史试卷购买网页二维码"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="service-features">
                                <p class="service-features-title">高考诊断试题特点</p>
                                <div class="service-feature-cards">
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">价值引领</p>
                                        <p class="service-feature-text">
                                            试题体现正确的政治方向和价值取向，引导学生形成正确的世界观、人生观和价值观
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">考查全面</p>
                                        <p class="service-feature-text">
                                            试题内容符合新高考趋势，对学生学科素养、关键能力和必备知识进行全面考查
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">科学性和时代性</p>
                                        <p class="service-feature-text">
                                            试题结合当前社会、科技、文化发展，考查对新知识和技能的掌握和应用能力
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">基础性和综合性</p>
                                        <p class="service-feature-text">
                                            试题涵盖高中段基础知识，同时考查综合运用知识解决实际问题的能力
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">应用性和创新性</p>
                                        <p class="service-feature-text">
                                            试题中设计实际应用场景，考查学生创新能力和运用理论知识解决问题能力
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">情境设计</p>
                                        <p class="service-feature-text">
                                            试题融入生活、学习等实际情境，考查学生在具体情境中运用知识解决问题能力
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- TDA加试科目试题介绍 -->
                <div class="addition-subject-dev-intro intro">
                    <h3 class="intro-title heading-tertiary">
                        <!--<span class="intro-title-number">02 </span>-->
                        <span class="intro-title-text">强基诊断：大学视角，深度评估，助力顶尖人才评价</span>
                    </h3>
                    <div class="intro-content">
                        <div class="addition-subject-section intro-section">
                            <div class="service">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>强基诊断</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">
                                            TDA-G12 强基诊断科目适合具备数理单科特长或有志于各高校相关学术水平考试的学生参加。试题对标顶尖高校强基笔试难度，体现大学选才视角，注重基础深度、综合性和创新性，全面评估学生的学科素养、专业知识根基和综合运用能力。命题专家团队均来自 985 高校数理方向相关专业，确保试题的专业性与权威性。
                                        </span>
                                    </p>
                                    <!--<div class="subject-resource">
                                        <a href="https://www.cssat.cn/example/强基诊断科目样卷.zip"
                                           class="btn btn--full btn--download"
                                        >
                                            <span>下载强基诊断科目样卷</span>
                                            <i class="ph-bold ph-download-simple icon--download"></i>
                                        </a>
                                    </div>-->
                                </div>
                            </div>
                            <div class="service-features">
                                <p class="service-features-title">试题特点</p>
                                <div class="service-feature-cards">
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">注重基础</p>
                                        <p class="service-feature-text">
                                            试题着重考查学科基础知识，注重对知识核心概念和原理的透彻理解及灵活运用
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">综合性强</p>
                                        <p class="service-feature-text">
                                            试题突出学科交叉与融合，考查综合运用知识的能力和跨学科思维的深度与广度
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">创新性强</p>
                                        <p class="service-feature-text">
                                            试题形式新颖，强调考查学生的创新思维和利用创新思维解决问题的能力
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">深度与难度较高</p>
                                        <p class="service-feature-text">
                                            试题要求对知识本质和内在联系的深入理解，充分评估学生的数理学科潜质
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="cbt-sectinon intro-section">
                            <div class="service service--cbt">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>线上机考服务</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">线上机考模式由于其更大程度保障了考试严肃性且实施更便利等特点，正被越来越多高水平大学“强基计划”及其他各类“大学校考”采用。为让考生更熟悉线上机考形式，TDA除提供线下纸笔考试形式，还提供线上机考形式。</span>
                                        <span class="paragraph">TDA线上机考遵循严肃性“大学校考”实施框架，并由于其最大程度保障了<a
                                                class="text-link text-link--cbt"
                                                href="#supplement-features-cbt"
                                        ><i class="ph ph-link text-icon"></i
                                        >评估结果可靠和有效性</a
                                        >，对于线上机考考生支持<a
                                                class="text-link text-link--cbt"
                                                href="#certification-intro"
                                        ><i class="ph ph-link text-icon"></i>认证成绩单申请</a
                                        >。
                      </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- section-考试服务介绍 -->
        <section class="section-intro section">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--features">
                    <p class="section-title">
                        <span class="section-title-text">高严肃性考试实施</span>
                    </p>
                </h2>

                <!-- 成绩保障介绍 -->
                <div class="implement-intro intro">
                    <h3 class="intro-title heading-tertiary">
                        <!--<span class="intro-title-number">03 </span>-->
                        <span class="intro-title-text">高严肃性考试实施标准，保障评估结果可信、有效</span>
                    </h3>
                    <div class="intro-content">
                        <div class="procedure-section intro-section">
                            <div class="service">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>高严肃性标准化考试实施</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">TDA采用高严肃性考试实施标准，通过对内标准化保障机制、对外标准化实施指引、信息技术、人工智能等多种手段，系统性保障考试试题质量、考试安全性、稳定性、公平性和数据可靠性，从而让评估结果具备更高可信度和有效性。</span>
                                    </p>
                                </div>
                            </div>
                            <div class="service-features">
                                <p class="service-features-title">标准化考试服务保障</p>
                                <div class="service-feature-cards">
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">试题质量保障</p>
                                        <p class="service-feature-text">
                                            题目命制严格遵循"命、审、校(初)、排、校(终)"流程，分工明确，且试题均经过严格的原创性检查
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">试题安全保障</p>
                                        <p class="service-feature-text">
                                            制题人员签订保密协议，制题全程采用"背对背"原则，且试题与答题卡均采用带密码锁的保密袋(箱)运输
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">实施质量保障</p>
                                        <p class="service-feature-text">
                                            为中学各类实施角色提供针对性的、明晰的实施指引，并采用信息化管理系统对考试全流程进行管理
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">考试公平性保障</p>
                                        <p class="service-feature-text">
                                            统一发放保密袋(箱)开锁密码和机考开考密钥确保统一开考，阅卷采用线上"联考联阅"模式
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">数据可靠性保障</p>
                                        <p class="service-feature-text">
                                            对报名、参试、扫描等数据进行校验和确认，并对成绩进行多轮自动化检查和5‰随机抽样手工核对
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="supplement" id="supplement-features-cbt">
                            <p class="supplement-title">采用多种技术手段增强机考成绩质量</p>
                            <div class="cbt-procedure-section intro-section">
                                <div class="cbt-features service-features">
                                    <ul class="cbt-feature-list">
                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>采用多种加密算法对机考电子化试题加密</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--safe"
                                            >安全性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>采用多层加密进行数据安全传输防攻击措施</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--safe"
                                            >安全性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>机考全程实时监控，确保考试过程可回溯</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--fair"
                                            >公平性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>机考系统自动屏蔽与考试无关的应用程序</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--fair"
                                            >公平性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>机考软件锁屏、支持自动抓取切屏画面和预警</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--fair"
                                            >公平性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>答案多途径回收、一致性检查兼防篡改校验</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--realiability"
                                            >可靠性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>考生作答完整行为数据实时保存，考后可回溯</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--realiability"
                                            >可靠性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="img-box">
                                    <img
                                            class="cbt-procedure-img"
                                            src="../../assets/image/relationship.png"
                                            alt="真实的机考实施相关图片"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- section-考试服务介绍 -->
        <section class="section-intro section">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--features">
                    <p class="section-title">
                        <span class="section-title-text">认证成绩单</span>
                    </p>
                </h2>

                <!-- 认证成绩单介绍 -->
                <div class="certification-intro intro" id="certification-intro">
                    <h3 class="intro-title heading-tertiary">
                        <!--<span class="intro-title-number">04 </span>-->
                        <span class="intro-title-text">考试成绩认证，供学生向成绩采信方提交成绩证明</span>
                    </h3>
                    <div class="intro-content">
                        <div class="certification-section intro-section">
                            <div class="service service--cbt">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>认证成绩单(仅限线上机考)</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">
                                            参加TDA线上机考的考生可在学生系统中申请认证成绩单。认证成绩单是TDA考试的防伪成绩证明，可向成绩采信方提交。认证成绩单分为纸质版和电子版两种，申请成功后两种形式可同时获取。
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="certification-features service-features">
                                <!-- 认证成绩单本身特点介绍 -->
                                <figure class="service-feature-figure--vertical">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">认证成绩单</p>
                                        <p class="service-feature-text">
                                            认证成绩单是针对线上机考考生的官方成绩证明，主要体现考生成绩及各地域范围内的排名数据。纸质认证成绩单选用优质纸张、印刷清晰、包装精致。
                                        </p>
                                    </div>
                                    <img
                                            class="certif-img service-feature-figure-img"
                                            src="../../assets/img/tda-cert/report.webp"
                                            alt="认证成绩单与包装示意图"
                                    />
                                </figure>

                                <!-- 认证成绩单数据验证特点介绍 -->
                                <figure class="service-feature-figure--vertical">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">成绩数据验证</p>
                                        <p class="service-feature-text">
                                            每份成绩单均设有唯一的认证二维码和认证编号，使用者可通过<a
                                                class="text-link text-link--cbt"
                                                href="https://yanzheng.cssat.cn/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                        ><i class="ph ph-link text-icon"></i>官方验证网站</a
                                        >对成绩数据进行验证，有效防伪，确保成绩数据的真实性和可靠性。
                                        </p>
                                    </div>
                                    <img
                                            class="certif-img service-feature-figure-img"
                                            src="../../assets/img/tda-cert/validation.png"
                                            alt="成绩单数据验证网站示意图"
                                    />
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- section-考试服务介绍 -->
        <section class="section-intro section">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--features">
                    <p class="section-title">
                        <span class="section-title-text">试题讲义</span>
                    </p>
                </h2>

                <!-- 试题讲义介绍 -->
                <div class="handouts-intro intro">
                    <h3 class="intro-title heading-tertiary">
                        <span class="intro-title-text">试题讲义，「数据驱动+深度解析」的教学利器</span>
                    </h3>
                    <div class="intro-content">
                        <div class="certification-section intro-section">
                            <div class="service">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>试题讲义</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">
                                            考后，考试项目组将向中学提供当次考试的试题讲义。试题讲义是深度整合了考试数据分析与题目解析的综合性教学辅助文件，用于任课老师的题目讲解。TDA 试题讲义按使用角色分为试题讲义(年级版)和试题讲义(班级版)。
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="certification-features service-features">
                                <!-- 认证成绩单本身特点介绍 -->
                                <figure class="service-feature-figure--vertical">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">试题讲义(年级版)</p>
                                        <p class="service-feature-text">旨在为学科负责人对全年级教学状况的分析提供参考。</p>
                                    </div>
                                    <img
                                            class="student-report-img service-feature-figure-img"
                                            src="../../assets/image/explain/explain_grade.png"
                                            alt="试题讲义(年级版)示意图"
                                    />
                                </figure>

                                <!-- 认证成绩单数据验证特点介绍 -->
                                <figure class="service-feature-figure--vertical">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">试题讲义(班级版)</p>
                                        <p class="service-feature-text">旨在为任课老师的班级教学分析提供参考。</p>
                                    </div>
                                    <img
                                            class="student-report-img service-feature-figure-img"
                                            src="../../assets/image/explain/explain_class.png"
                                            alt="试题讲义(班级版)示意图"
                                    />
                                </figure>
                            </div>
                        </div>
                        <!--<div class="section-handouts-area">
                            <div class="section-handouts-item">
                                <div class="section-handouts-item-title">
                                    <div class="title-number">01</div>
                                    <div>考试第二天发布初版讲义，高效助力次日试题讲解</div>
                                </div>
                                <div class="section-handouts-item-text">
                                    考试第二天，考试项目组发布包含完整试题解析及客观题数据的初版讲义。方便老师次日进行试题分析与讲解，帮助学生趁热打铁，精准定位知识"漏洞"，及时查漏补缺。待阅卷工作结束后考试项目组发布完整的试题讲义，补充主观题数据，提供更全面的分析支持。
                                </div>
                            </div>
                            <div class="section-handouts-item">
                                <div class="section-handouts-item-title">
                                    <div class="title-number">02</div>
                                    <div>"干扰项分析"精准识别易丢分选项，助力老师定位讲解重点</div>
                                </div>
                                <div class="section-handouts-item-text">
                                    每道选择题配有选项数据表，展示各选项在班级、校级与省级的选择比例，并标注正确选项与"干扰项"。"干扰项"指容易导致学生丢分的错误选项，即根据本班学生在各选项的选择比例，筛选出的选择率较高的错误选项。
                                </div>
                                <div class="paraphrase-area">
                                    <div class="paraphrase-area-title">选项数据表元素释义：</div>
                                    <div class="paraphrase-area-list">
                                        <div class="paraphrase-area-item">
                                            <div class="title-number">1</div>
                                            <div>表示正确选项</div>
                                        </div>
                                        <div class="paraphrase-area-item">
                                            <div class="title-number">2</div>
                                            <div>表示"干扰项"（本班选择比例超过 25% 的错误选项）</div>
                                        </div>
                                        <div class="paraphrase-area-item">
                                            <div class="title-number">3</div>
                                            <div>表示"未选择"</div>
                                        </div>
                                        <div class="paraphrase-area-item">
                                            <div class="title-number">4</div>
                                            <div>表示没有人选择，或选择比例为 0</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-handouts-item-img">
                                    <img class="certif-img service-feature-figure-img"
                                         src="../../assets/image/explain/explain_option.png"
                                         alt="试题解析选项数据表示意图"
                                    />
                                </div>
                            </div>
                            <div class="section-handouts-item">
                                <div class="section-handouts-item-title">
                                    <div class="title-number">03</div>
                                    <div>"得分率展示"直观反映各层级水平，帮助老师掌握班级相对水平</div>
                                </div>
                                <div class="section-handouts-item-text">
                                    每道题的最上方显示该题在本班、本校、本省范围内的得分率，即该题在本班、本校、本省范围内考生均分与该题满分的比值。任课老师可通过这些数据直观对比本班学生在每道题上的表现与本校、本省平均水平的差距，精准了解本班学生在学科知识与能力掌握上的相对水平。
                                </div>
                                <div class="section-handouts-item-img">
                                    <img class="certif-img service-feature-figure-img"
                                         src="../../assets/image/explain/explain_average.png"
                                         alt="试题解析得分率示意图"
                                    />
                                </div>
                            </div>
                            <div class="section-handouts-item">
                                <div class="section-handouts-item-title">
                                    <div class="title-number">04</div>
                                    <div>试题解析及采分点清晰详尽，全面提升老师备课效率</div>
                                </div>
                                <div class="section-handouts-item-text">
                                    每道试题均附有完整的解析、明确的采分点及其分值。这有助于老师快速锁定学生的"丢分点"，明确解题思路与方法，并进行清晰的知识点讲解提升课堂讲解与备课效率。
                                </div>
                                <div class="section-handouts-item-img">
                                    <img class="certif-img service-feature-figure-img"
                                         src="../../assets/image/explain/explain_point.png"
                                         alt="试题解析采分点示意图"
                                    />
                                </div>
                            </div>
                        </div>-->
                    </div>
                </div>
            </div>
        </section>

        <!-- section-考试服务介绍 -->
        <section class="section-intro section">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--features">
                    <p class="section-title">
                        <span class="section-title-text">数据报告</span>
                    </p>
                </h2>

                <!-- 数据分析报告介绍 -->
                <div class="data-intro intro">
                    <h3 class="intro-title heading-tertiary">
                        <!--<span class="intro-title-number">05 </span>-->
                        <span class="intro-title-text">分析数据详实，为教学和备考提供强指引</span>
                    </h3>
                    <div class="intro-content">
                        <div class="school-report-section intro-section">
                            <div class="service">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>考试分析报告-中学版</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                      <span class="paragraph"
                      >中学考试分析报告旨在帮助参试中学根据评估结果明确教学提升方向，进而有针对性地优化教学策略。中学考试分析报告分为综合报告和分科报告。综合报告旨在让教学管理者了解本校总成绩及学科成绩整体表现，在宏观上把握教学情况。分科报告旨在让学科老师了解各学科学生的整体表现，从而明确教学方向、优化教学策略。
                      </span>
                                    </p>
                                </div>
                            </div>
                            <div class="school-report-features service-features">
                                <p class="service-features-title">中学报告图表介绍</p>
                                <!-- 中学报告特点1 -->
                                <figure class="service-feature-figure--horizon">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">成绩表现概况</p>
                                        <p class="service-feature-text">
                                            呈现各学科平均分、标准差(系数)、平均分和优生在全国或全省范围的校级横向对比等数据，让教学管理者多角度洞察本校整体成绩表现
                                        </p>
                                    </div>
                                    <img
                                            class="service-feature-figure-img"
                                            src="../../assets/img/tda-data/school-report-1.webp"
                                            alt="中学报告成绩表现概况示意图"
                                    />
                                </figure>

                                <!-- 中学报告特点2 -->
                                <figure
                                        class="service-feature-figure--horizon horizon-figure--reversed"
                                >
                                    <img
                                            class="service-feature-figure-img"
                                            src="../../assets/img/tda-data/school-report-2.webp"
                                            alt="中学报告学科平均表现示意图"
                                    />
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">学科平均表现</p>
                                        <p class="service-feature-text">
                                            呈现各学科平均分及本校平均分相对于本省考生平均分、本身优生平均分和全国优生平均分的相对位置，让教学管理者明确本校学科优劣势
                                        </p>
                                    </div>
                                </figure>

                                <!-- 中学报告特点3 -->
                                <figure class="service-feature-figure--horizon">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">成绩分布</p>
                                        <p class="service-feature-text">
                                            呈现“纸笔”和“机考”两类考生总成绩和各学科的成绩分布，让教学管理者直观地了解本校成绩的整体集中度和差异度，及两类考生的差异程度
                                        </p>
                                    </div>
                                    <img
                                            class="service-feature-figure-img"
                                            src="../../assets/img/tda-data/school-report-3.webp"
                                            alt="中学报告成绩分布示意图"
                                    />
                                </figure>

                                <!-- 中学报告特点4 -->
                                <figure
                                        class="service-feature-figure--horizon horizon-figure--reversed"
                                >
                                    <img
                                            class="service-feature-figure-img"
                                            src="../../assets/img/tda-data/school-report-4.webp"
                                            alt="中学报告知识点表现概况示意图"
                                    />
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">知识点表现概况</p>
                                        <p class="service-feature-text">
                                            呈现各知识点本校平均得分率、考查频率、及全国和本省范围的整体或优生平均得分率，让学科老师明确学科知识点优劣势和教学重点
                                        </p>
                                    </div>
                                </figure>

                                <!-- 中学报告特点5 -->
                                <figure class="service-feature-figure--horizon">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">知识点表现对比</p>
                                        <p class="service-feature-text">
                                            通过箱型图呈现各学科知识点下本省各中学平均得分率的分布，了解本校平均得分率的相对位置，让学科老师从知识点视角了解科目优劣势
                                        </p>
                                    </div>
                                    <img
                                            class="service-feature-figure-img"
                                            src="../../assets/img/tda-data/school-report-5.webp"
                                            alt="中学报告知识点表现对比示意图"
                                    />
                                </figure>

                                <!-- 中学报告特点6 -->
                                <figure
                                        class="service-feature-figure--horizon horizon-figure--reversed"
                                >
                                    <img
                                            class="service-feature-figure-img"
                                            src="../../assets/img/tda-data/school-report-6.webp"
                                            alt="中学报告作答时长示意图"
                                    />
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">作答时长</p>
                                        <p class="service-feature-text">
                                            呈现线上机考考生作答时在各题作答界面的停留时长(可近似看作答题时长)，让学科老师了解学生作答时长分配从而识别学生作答策略问题
                                        </p>
                                    </div>
                                </figure>
                            </div>
                        </div>
                        <div class="student-report-section intro-section">
                            <div class="service">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>考试分析报告-学生版</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                      <span class="paragraph"
                      >TDA向参试学生提供学生考试分析报告作为个人学习的参考，旨在帮助参试学生根据评估结果明确高考或“强基计划”备考方向，进而有针对性地优化学习策略。
                      </span>
                                    </p>
                                </div>
                            </div>
                            <div class="student-report-features service-features">
                                <figure class="service-feature-figure--vertical">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">基础报告</p>
                                        <p class="service-feature-text">
                                            基础报告内容为学生当次测试的客观数据，包含学生在当次测试中的总成绩、单科成绩，及成绩在全国、本省、本校范围内的排名情况，并包括各科的各题型、各知识点下的数据表现
                                        </p>
                                    </div>
                                    <img
                                            class="student-report-img service-feature-figure-img"
                                            src="../../assets/image/TDA/report_G12.jpg"
                                            alt="基础报告示意图"
                                    />
                                </figure>
                                <figure class="service-feature-figure--vertical">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">预测报告</p>
                                        <p class="service-feature-text">
                                            预测报告内容以学生考试客观数据为基础并通过统计推断得出的推断类型数据，包括单科高考预测分和百分比排名(标测数据指标)，以及基于标测数据得出的“强基计划”入围概率
                                        </p>
                                    </div>
                                    <img
                                            class="student-report-img service-feature-figure-img"
                                            src="../../assets/img/tda-data/预测报告.webp"
                                            alt="预测报告示意图"
                                    />
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- section-参加TDA -->
        <section class="section-procedure section">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--procedure">
                    <p class="section-title">
                        <span class="section-title-text">参加诊断性测试(TDA)</span>
                    </p>
                </h2>
                <div class="heading-third">
                    TDA-G12的参试方式分为中学参试和个人参试两类。中学参试分为「线上机考」和「线下纸笔」两种形式，与原TDA-G12模式相同，以中学为单位报名，并由中学统一安排和组织学生进行测试。此外，TDA-G12针对「强基诊断」新增采用「居家考」考试形式的个人参试形式，支持个人报名。学生可在规定时间内在家中进行测试。
                </div>
                <div class="section-content">
                    <h3 class="heading-tertiary">个人参试</h3>
                    <!-- 个人参试 -->
                    <div class="procedure-subsection">
                        <div class="signUp-entrance-process">
                            <h3 class="heading-sixth">报名入口</h3>
                            <div class="signUp-entrance-info">您可以选择以下任意一种方式进行报名：</div>
                            <div class="signUp-entrance-box">
                                <div class="signUp-entrance-box-title">官方网站</div>
                                <div class="entrance-process-text">
                                    在本网站内点击【个人登录】，使用个人账号密码登录。如无账号，请先完成新用户注册。登录后，进入考试列表页面，选择您想要参加的考试进行报名。
                                </div>
                            </div>
                            <div class="signUp-entrance-box">
                                <div class="signUp-entrance-box-title">微信服务号</div>
                                <div class="entrance-process-text">扫描网站底部"CSSAT
                                    微信服务号二维码"，关注"标准学术能力测试"。点击底部菜单栏【服务】→【考试报名】进入考试列表页面，选择您想要参加的考试进行报名。
                                </div>
                            </div>
                        </div>
                        <!--<div class="signUp-entrance-process">
                            <h3 class="heading-sixth">报名流程（以微信服务号为例）</h3>
                            <div class="signUp-process-box">
                                <i class="ph-bold ph-number-one signUp-process-box-num"></i>
                                <div class="entrance-process-text">
                                    <div>点击服务号底部菜单【服务】→【考试报名】。</div>
                                    <div class="disc">已参加过 CSSAT 序列考试的考生，可使用身份证号及密码登录（初始密码为身份证后 6 位，如最后一位为 X，请大写）。</div>
                                    <div class="disc">未参加过 CSSAT 序列考试的考生需先注册新用户后再登录。</div>
                                </div>
                            </div>
                            <div class="signUp-process-box">
                                <i class="ph-bold ph-number-two signUp-process-box-num"></i>
                                <div class="entrance-process-text">
                                    填写邀请码（如无邀请码可直接点击【下一步】）。
                                </div>
                            </div>
                            <div class="signUp-process-box">
                                <i class="ph-bold ph-number-three signUp-process-box-num"></i>
                                <div class="entrance-process-text">
                                    在下拉列表中选择考点城市后点击【预定】，考点城市支持跨省市选择及报名。若考点城市名额已满，可点击【申请候补】进行考位候补。
                                </div>
                            </div>
                            <div class="signUp-process-box">
                                <i class="ph-bold ph-number-four signUp-process-box-num"></i>
                                <div class="entrance-process-text">
                                    在"确认报名信息"页面点击【立即支付】完成报名。如需更换考点城市，请在支付前点击【取消预定】返回上一步。
                                </div>
                            </div>
                            <div class="signUp-process-box">
                                <i class="ph-bold ph-number-five signUp-process-box-num"></i>
                                <div class="entrance-process-text">
                                    支付完成后，即报名成功。
                                </div>
                            </div>
                        </div>
                        <div class="signUp-entrance-process">
                            <h3 class="heading-sixth">注意事项</h3>
                            <div class="signUp-matter-box">
                                <div class="entrance-process-text">
                                    <div class="disc">注册时如在学校列表中未找到所在学校，可发送邮件至 service@cssat.cn 说明情况并注明中学全称。</div>
                                </div>
                                <div class="entrance-process-text">
                                    <div class="disc">已支付后如需换考点城市，须在报名截止前退掉原考位再重新报名（热门省份的考位数量变化较快，可能存在退后无法再报名的风险）。</div>
                                </div>
                            </div>
                        </div>-->
                    </div>
                    <h3 class="heading-tertiary">中学参试</h3>
                    <!-- TDA参与全流程 -->
                    <div class="procedure-subsection">
                        <h3 class="heading-sixth heading-sixth--mb">TDA参试与服务流程</h3>
                        <div class="procedure-subsection-content subsection-content">
                            <!-- step1 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-one step-number"></i>
                                    <span>考试报名</span>
                                </p>
                                <p class="step-content">
                                    在CSSAT中学系统中导入参试学生名单信息完成考试报名。如未获得中学系统的账号和密码，可填写<a
                                        class="text-link"
                                        href="#register-subsection"
                                ><i class="ph ph-link text-icon"></i>报名申请信息</a
                                >
                                    进行网上申请或直接<a class="text-link" href="#footer"
                                ><i class="ph ph-link text-icon"></i>联系考试项目组</a
                                >
                                </p>
                            </div>

                            <!-- step2 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-two step-number"></i>考前准备
                                </p>
                                <p class="step-content">
                                    接收考试项目组寄送的试卷、答题卡及其他相关物料，并阅读各角色考试实施指引熟悉相关实施操作。如参与线上机考，需提前按要求完成监控布置和考试软件准备
                                </p>
                            </div>

                            <!-- step3 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-three step-number"></i
                                    >考中实施
                                </p>
                                <p class="step-content">
                                    考前及时接收保密袋(箱)开锁密码、开袋(箱)获取并分发试卷和答题卡。如参加机考，需获取并公布开考密钥。考中认真监考，如遇异常与考试项目组沟通解决
                                </p>
                            </div>

                            <!-- step4 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-four step-number"></i>数据回传
                                </p>
                                <p class="step-content">
                                    考试结束后配合考试项目组完成答题卡扫描与上传。如参加机考，配合考试项目组完成考生机考作答数据回收，并在规定时间内向考试项目组上传本地监控录制视频文件
                                </p>
                            </div>

                            <!-- step5 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-five step-number"></i>线上阅卷
                                </p>
                                <p class="step-content">
                                    及时接收考试项目组分发的阅卷参考答案与评分标准、各科阅卷账号和密码，并在考后及时完成线上阅卷。如对答案有疑义，及时向考试项目组写邮件告知
                                </p>
                            </div>

                            <!-- step6 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-six step-number"></i
                                    >成绩与报告获取
                                </p>
                                <p class="step-content">
                                    考试当日内中学可获得客观题数据分析及完整试题解析。阅卷结束后当周获得成绩明细表格、各类分析报告。学生可获得考试分析报告或申请认证成绩单
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- TDA参与全流程 -->
                    <div class="register-subsection" id="register-subsection">
                        <div class="register-text-box">
                            <h2 class="heading-secondary">提交申请表进行考试报名申请</h2>
                            <p class="register-text">
                                TDA报名需在CSSAT中学系统中完成。如还未有系统账号和密码，请先填写并提交以下申请表或直接联系考试项目组获取。提交申请后，考试项目组会与你联系并向你提供相关账号和密码。如已有中学系统账号和密码，请直接<a
                                    class="text-link"
                                    href="#"
                            ><i class="ph ph-link text-icon"></i>进入中学系统进行报名</a
                            >。
                            </p>
                            <div class="register-form" name="sign-up">
                                <!-- 中学省份筛选 -->
                                <div class="form-item">
                                    <label for="school-province">中学省份:</label>
                                    <select
                                            v-model="formData.province_id"
                                            id="school-proince-selection"
                                            name="school-proince-selection"
                                            required
                                            :class="!formData.province_id?'no-value':''"
                                            @blur="validateProvince"
                                            @change="onChangeProvince"
                                    >
                                        <option value="">请选择中学省份</option>
                                        <option v-for="(item, index) in provinceList"
                                                :value="item.id"
                                        >{{item.name}}
                                        </option>
                                    </select>
                                    <span v-if="provinceErr" class="input-error">{{provinceErrMsg}}</span>
                                </div>

                                <!-- 中学城市筛选 -->
                                <div class="form-item">
                                    <label for="school-city">中学城市:</label>
                                    <select
                                            v-model="formData.city_id"
                                            id="school-city-selection"
                                            name="school-city-selection"
                                            required
                                            :class="!formData.city_id?'no-value':''"
                                            @blur="validateCity"
                                    >
                                        <option value="">请选择中学城市</option>
                                        <option v-for="(item, index) in cityList"
                                                :value="item.id"
                                        >{{item.name}}
                                        </option>
                                    </select>
                                    <span v-if="cityErr" class="input-error">{{cityErrMsg}}</span>
                                </div>

                                <!-- 中学名称筛选 -->
                                <div class="form-item">
                                    <label for="school">中学名称:</label>
                                    <input
                                            v-model="formData.school_name"
                                            id="school-selection"
                                            type="text"
                                            placeholder="请填写真实中学名称"
                                            name="school-selection"
                                            required
                                            @blur="validateSchool"
                                    />
                                    <span v-if="schoolErr" class="input-error">{{schoolErrMsg}}</span>
                                </div>

                                <!-- 联系人姓名 -->
                                <div class="form-item">
                                    <label for="name">联系人姓名:</label>
                                    <input
                                            v-model="formData.contact_person"
                                            id="input-name"
                                            type="text"
                                            placeholder="请填写真实联系人"
                                            name="input-email"
                                            required
                                            @blur="validatePerson"
                                    />
                                    <span v-if="contactPersonErr" class="input-error">{{contactPersonErrMsg}}</span>
                                </div>

                                <!-- 联系人邮箱 -->
                                <div class="form-item">
                                    <label for="email">联系邮箱:</label>
                                    <input
                                            v-model="formData.email"
                                            id="input-email"
                                            type="email"
                                            placeholder="请填写常用邮箱"
                                            name="input-email"
                                            required
                                            @blur="validateEmail"
                                    />
                                    <span v-if="emailErr" class="input-error">{{emailErrMsg}}</span>
                                </div>

                                <!-- 联系人电话 -->
                                <div class="form-item">
                                    <label for="phone">联系电话:</label>
                                    <input
                                            v-model="formData.contact_phone"
                                            id="input-phone"
                                            type="text"
                                            placeholder="请填写联系手机号或固话"
                                            name="input-phone"
                                            required
                                            @blur="validatePhone"
                                    />
                                    <span v-if="phoneErr" class="input-error">{{phoneErrMsg}}</span>
                                </div>

                                <button class="btn btn--form" @click="onApply()">提交申请</button>
                                <div class="register-dialog" v-if="errMsgShow">{{errMsg}}</div>
                            </div>
                        </div>
                        <div
                                class="register-img-box"
                                role="img"
                                aria-label="填写申请表的配图"
                        ></div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {apply, getCityList, getProvinceList} from "@/request";

    export default {
        name: "TDA-G12",
        data() {
            return {
                loading: false,
                formData: {
                    province_id: '',
                    city_id: '',
                    school_name: '',
                    contact_person: '',
                    email: '',
                    contact_phone: '',
                    action: 'gw',
                },
                provinceErr: false,
                provinceErrMsg: '',
                cityErr: false,
                cityErrMsg: '',
                schoolErr: false,
                schoolErrMsg: '',
                contactPersonErr: false,
                contactPersonErrMsg: '',
                emailErr: false,
                emailErrMsg: '',
                phoneErr: false,
                phoneErrMsg: '',
                errMsgShow: false,
                errMsg: '',
                cityOption: {},
                provinceList: [],
                cityList: [],
            }
        },
        mounted() {
            this.getProvince();
            this.getCity();
        },
        methods: {
            // 邮箱正则
            ruleEmail(email) {
                let emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                return emailRegex.test(email);
            },
            // 手机号|固话正则
            rulePhone(phone) {
                // 匹配手机号的正则
                const phoneRegex = /^(\+?\d{1,4})?\s*-?\s*(\(?\d{3,4}\)?)\s*-?\s*(\d{3,4})\s*-?\s*(\d{4})$/;
                // 匹配固定电话的正则
                const fixedPhoneRegex = /^(\+?\d{1,4})?\s*-?\s*(\d{3,4})\s*-?\s*(\d{3,4})$/;
                return phoneRegex.test(phone) || fixedPhoneRegex.test(phone);
            },
            validateProvince() {
                if (!this.formData.province_id) {
                    this.provinceErr = true;
                    this.provinceErrMsg = '请选择中学省份！';
                    return true;
                } else {
                    this.provinceErr = false;
                    this.provinceErrMsg = '';
                    return false;
                }
            },
            validateCity() {
                if (!this.formData.city_id) {
                    this.cityErr = true;
                    this.cityErrMsg = '请选择中学城市！';
                    return true;
                } else {
                    this.cityErr = false;
                    this.cityErrMsg = '';
                    return false;
                }
            },
            validateSchool() {
                if (!this.formData.school_name) {
                    this.schoolErr = true;
                    this.schoolErrMsg = '请填写真实中学名称！';
                    return true;
                } else {
                    this.schoolErr = false;
                    this.schoolErrMsg = '';
                    return false;
                }
            },
            validatePerson() {
                if (!this.formData.contact_person) {
                    this.contactPersonErr = true;
                    this.contactPersonErrMsg = '请填写真实联系人！';
                    return true;
                } else {
                    this.contactPersonErr = false;
                    this.contactPersonErrMsg = '';
                    return false;
                }
            },
            validateEmail() {
                if (!this.formData.email) {
                    this.emailErr = true;
                    this.emailErrMsg = '请填写常用邮箱！';
                    return true;
                } else if (!this.ruleEmail(this.formData.email)) {
                    this.emailErr = true;
                    this.emailErrMsg = '请填写正确格式的邮箱！';
                    return true;
                } else {
                    this.emailErr = false;
                    this.emailErrMsg = '';
                    return false;
                }
            },
            validatePhone() {
                if (!this.formData.contact_phone) {
                    this.phoneErr = true;
                    this.phoneErrMsg = '请填写联系手机号或固话！';
                    return true;
                } else if (!this.rulePhone(this.formData.contact_phone)) {
                    this.phoneErr = true;
                    this.phoneErrMsg = '请填写正确格式的手机号或固话！';
                    return true;
                } else {
                    this.phoneErr = false;
                    this.phoneErrMsg = '';
                    return false;
                }
            },
            // 提交申请
            async onApply() {
                let status = false;
                if (this.validateProvince()) {
                    status = true;
                }
                if (this.validateCity()) {
                    status = true;
                }
                if (this.validateSchool()) {
                    status = true;
                }
                if (this.validatePerson()) {
                    status = true;
                }
                if (this.validateEmail()) {
                    status = true;
                }
                if (this.validatePhone()) {
                    status = true;
                }
                if (status) return false;

                if (this.loading) return false;
                this.loading = true;

                let data = await apply(this.formData);
                this.errMsg = data.message;
                this.errMsgShow = true;
                setTimeout(() => {
                    this.errMsg = '';
                    this.errMsgShow = false;
                }, 3000)
                if (data.code != 200) {
                    this.loading = false;
                    return false;
                }
                this.loading = false;
                this.formData.province_id = '';
                this.formData.city_id = '';
                this.formData.school_name = '';
                this.formData.contact_person = '';
                this.formData.email = '';
                this.formData.contact_phone = '';
            },
            onChangeProvince() {
                this.formData.city_id = '';
                this.cityList = [];
                let pId = this.formData.province_id;
                let all_city = this.cityOption;
                let city_list = [];
                for (let key in all_city) {
                    if (pId == all_city[key]['parent_id']) {
                        city_list.push(all_city[key]);
                    }
                }
                this.cityList = city_list;
            },
            async getProvince() {
                let data = await getProvinceList();
                if (data.code != 200) return;
                this.provinceList = data.list;
            },
            async getCity() {
                let data = await getCityList();
                if (data.code != 200) return;
                this.cityOption = data.list;
            },
            downloadFile(name) {
                let href = parent.window.location.origin + '/example/' + name;
                console.log(href);
                window.location.href = href;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../assets/css/main--tda.css';
    @import '../../assets/css/queries--tda.css';
    @import '../../assets/scss/main--tda.scss';
    @import '../../assets/scss/queries--tda.scss';

    .form-item {
        position: relative;
    }

    .input-error {
        position: absolute;
        top: 100%;
        left: 0;
        color: #f56c6c;
        font-size: 1.1rem;
        line-height: 1;
        padding-top: 0.4rem;
    }

    .register-form {
        position: relative;
    }

    .register-dialog {
        position: absolute;
        left: 50%;
        top: 60%;
        transform: translate(-50%, -50%);
        font-size: 1.2rem;
        background-color: #000000;
        padding: 1rem 1.2rem;
        border-radius: 0.6rem;
        opacity: 0.85;
    }

</style>
